import React from 'react'
import { FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core'
import { CHEMISTRY_OPTIONS, DEFAULT_CHEMISTRY } from 'src/utils/bedChemistry'

// The library chemistry of a capture kit being uploaded. Always has a value
// (hybrid capture unless changed), so it never blocks an upload.
const BedChemistryField = ({ value, onChange, name = 'chemistry', disabled = false, sx }) => (
  <>
    <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block', ...sx }}>
      Library chemistry:
    </Typography>
    <RadioGroup
      row
      aria-label="Library chemistry"
      name={name}
      value={value || DEFAULT_CHEMISTRY}
      onChange={(e) => onChange(e.target.value)}
      sx={{ ml: -1 }}
    >
      {CHEMISTRY_OPTIONS.map((option) => (
        <FormControlLabel
          key={option.value}
          value={option.value}
          disabled={disabled}
          control={<Radio size="small" />}
          label={<Typography variant="body2">{option.label}</Typography>}
        />
      ))}
    </RadioGroup>
  </>
)

export default BedChemistryField
